/* COMPLETE ELIXIR typography tidy.
   The brand does not use the em dash. Product descriptions, articles and
   page content still carry them from older copy, so they are replaced as the
   page renders.

     <strong>Label</strong> — text   ->   <strong>Label</strong>: text
     ... stressors — unveiling ...   ->   ... stressors, unveiling ...

   Nothing in the stored product data is changed. Remove this file from
   layout/theme.liquid to undo. */
(function () {
  'use strict';
  var EM = /—/;
  var LABEL = /^(STRONG|B|H1|H2|H3|H4|H5|H6|EM|I)$/;
  var SKIP = /^(SCRIPT|STYLE|TEXTAREA|CODE|PRE)$/;

  function tidy(node) {
    var t = node.nodeValue;
    if (!t || !EM.test(t)) return;
    var prev = node.previousSibling;
    // A dash opening the node right after a bold label reads as a colon
    if (prev && prev.nodeType === 1 && LABEL.test(prev.nodeName) && /^\s*—/.test(t)) {
      t = t.replace(/^\s*—\s*/, ': ');
    }
    t = t.replace(/\s*—\s*/g, ', ');
    if (t !== node.nodeValue) node.nodeValue = t;
  }

  function sweep(root) {
    if (!root || !root.nodeType) return;
    if (root.nodeType === 3) { tidy(root); return; }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var list = [];
    var n;
    while ((n = walker.nextNode())) {
      if (n.parentNode && SKIP.test(n.parentNode.nodeName)) continue;
      if (EM.test(n.nodeValue)) list.push(n);
    }
    for (var i = 0; i < list.length; i++) tidy(list[i]);
  }

  function start() {
    sweep(document.body);
    if (!window.MutationObserver) return;
    // Apps and quick views draw after load, so keep watching
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var added = recs[i].addedNodes;
        for (var j = 0; j < added.length; j++) sweep(added[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
